module.exports = __webpack_public_path__ + "static/media/de-share-image.aba79d73.jpg";